module.exports = __webpack_public_path__ + "static/media/upvote.ae9c5b01.svg";